import React from 'react';
import { Helmet } from 'react-helmet';
import { BarChart3, Download, Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { Card, CardContent } from '@/components/ui/card';

export default function RelatoriosSystemPage() {
  const { toast } = useToast();

  const handleAction = () => {
    toast({
      title: "Construtor de Relatórios",
      description: "🚧 This feature isn't implemented yet—but don't worry! You can request it in your next prompt! 🚀",
    });
  };

  const reports = [
    "Processos por Status", "Processos por Comarca/Vara", 
    "Tarefas por Responsável", "Fluxo de Caixa Mensal",
    "Perícias Entregues", "Honorários Recebidos"
  ];

  return (
    <div className="p-8 max-w-7xl mx-auto space-y-6">
      <Helmet>
        <title>Relatórios - PROVATIO</title>
      </Helmet>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg text-[#193D6D]">
            <BarChart3 size={24} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Relatórios Customizados</h1>
            <p className="text-slate-500">Extraia insights e exporte dados do sistema.</p>
          </div>
        </div>
        <Button onClick={handleAction} className="bg-[#193D6D] hover:bg-blue-800 text-white">
          <Settings2 className="w-4 h-4 mr-2" /> Novo Relatório
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((report, idx) => (
          <Card key={idx} className="shadow-sm border-slate-200 hover:border-[#193D6D] transition-colors cursor-pointer" onClick={handleAction}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-semibold text-[#193D6D] mb-1">{report}</h3>
                  <p className="text-sm text-slate-500">Relatório predefinido com base nos registros do sistema.</p>
                </div>
                <Button variant="ghost" size="icon" className="shrink-0"><Download className="w-4 h-4 text-slate-400" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}